
        var result = require("!!../../../../node_modules/css-loader/index.js!./settings-base.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-base/settings-base.component.css
// module id = 2415
// module chunks = 1